import { render, staticRenderFns } from "./HyphenAuth.vue?vue&type=template&id=646ed401&scoped=true"
import script from "./HyphenAuth.vue?vue&type=script&setup=true&lang=js"
export * from "./HyphenAuth.vue?vue&type=script&setup=true&lang=js"
import style0 from "./HyphenAuth.vue?vue&type=style&index=0&id=646ed401&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "646ed401",
  null
  
)

export default component.exports